// const BASE_URL = "http://localhost:5000/api/";
// const BASE_URL = "https://testbackend.evventoz.com/api/";
const BASE_URL = "https://nodeback.evventoz.com/api/";


// const IMAGE_URL = "http://localhost:5000/uploads/";
// const IMAGE_URL = "https://testbackend.evventoz.com/uploads/";
const IMAGE_URL = "https://nodeback.evventoz.com/uploads/";
 
export { BASE_URL, IMAGE_URL };